// Pure view helpers. HC eligibility is resolved by the API, never by clients.
const normalizedKey = value => String(value || '').normalize('NFKC').trim().replace(/\s+/gu, ' ').toLowerCase();

export function pendingHcRouting(submission, workflow) {
  if (submission?.status !== 'Pending HC') return null;
  if (!workflow) return { status: 'loading', approvers: [] };
  if (workflow.unavailable === true) return { status: 'unavailable', approvers: [] };
  const key = normalizedKey(submission.companyKey);
  if (!key) return { status: 'configuration_error', approvers: [] };
  const configured = (workflow.routes || []).find(route => normalizedKey(route.companyKey) === key);
  if (configured) return configured;
  if (workflow.centralFallback?.configured) return {
    companyKey: key, status: 'central_fallback', source: 'fallback',
    ccdApprovalRequired: true, approvers: workflow.centralFallback.approvers || [],
  };
  return { companyKey: key, status: 'unconfigured', approvers: [] };
}

export function pendingHcNames(submission, workflow) {
  const route = pendingHcRouting(submission, workflow);
  if (!route) return '';
  if (route.status === 'loading') return 'Loading HC approvers…';
  if (route.status === 'unavailable') return 'HC directory unavailable';
  if (route.status === 'configuration_error') return 'Routing needs attention';
  if (!route.approvers?.length) return 'No active HC approvers';
  return route.approvers.map(person => person.resolved ? person.name : 'Unavailable HC approver').join(', ');
}

export function filterHcRoutes(routes, query = '') {
  const term = String(query || '').trim().toLowerCase();
  if (!term) return Array.isArray(routes) ? routes : [];
  return (Array.isArray(routes) ? routes : []).filter(route =>
    [route.companyKey, route.status, ...(route.approvers || []).flatMap(person => [person.name, person.email])]
      .some(value => String(value || '').toLowerCase().includes(term)));
}
